import { FacebookClientPayload } from '@/pages/api/tracking/facebook/facebookAPIUtils';

/**
 * Triggers a Facebook CAPI event by sending the payload to our server-side API route.
 * This function is safe to use on the client-side as no sensitive data is exposed.
 *
 * @param payload The type-safe event payload.
 */
export const triggerFacebookCAPIEvent = async (payload: FacebookClientPayload) => {
	try {
		await fetch('/api/tracking/facebook', {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json',
			},
			body: JSON.stringify(payload),
		});
	} catch (error) {
		console.error('Failed to trigger Facebook CAPI event:', error);
	}
};
